export default __webpack_public_path__ + "static/devops3-950bc50195981ec8ca6e1978fbedde90.jpg";